export { PagePostComponent as PagePost } from './component';



// WEBPACK FOOTER //
// ./src/pages/post/index.tsx